function setRootProperties() {
    const viewportWidth = window.innerWidth;
    const scrollbarWidth = (viewportWidth - document.documentElement.clientWidth);
    const targetScreenSize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--target-screen-size'));
    const designFactor = Math.min(viewportWidth - scrollbarWidth, 1920) / targetScreenSize;

    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

    if (window.matchMedia('(max-width: 1024px)').matches) {
        document.documentElement.style.setProperty('--design-factor', designFactor);
    } else {
        document.documentElement.style.setProperty('--design-factor', '');
    }
}

window.addEventListener('resize', setRootProperties);

setRootProperties();

export function targetPixelSize() {
    const root = document.documentElement;

    // Get values for --scrollbar-width and --target-screen-size
    const scrollbarWidth = parseFloat(getComputedStyle(root).getPropertyValue('--scrollbar-width'));
    const targetScreenSize = parseFloat(getComputedStyle(root).getPropertyValue('--target-screen-size'));

    // Get the viewport width
    const viewportWidth = window.innerWidth;

    // Calculate the result
    const result = Math.min(viewportWidth - scrollbarWidth, 1920) / targetScreenSize;

    return result;
}
